export default __webpack_public_path__ + "static/media/Bison-lodge.dc360bfe.jpg";